import { processSilentRenew } from 'redux-oidc';

const SilentRenewPage = () => {
    //testing
    processSilentRenew();

    return <></>
}

export default SilentRenewPage;